import { makeStyles } from '@mui/styles';
import { Select } from 'cleveron-web-components';
import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { getIssueStatusOptions, ISSUE_PARTNER_STATUSES } from '../../../../constants/issueStatuses';
import { useFormValues } from '../../../../form';

const useStyles = makeStyles(() => ({
    select: {
        minWidth: 200,
    },
}));

export default function Status({ disabled, domId }) {
    const { formatMessage } = useIntl();
    const classes = useStyles();
    const { statusId } = useFormValues(['statusId']);

    const index = ISSUE_PARTNER_STATUSES.indexOf(statusId);
    const statuses = [
        ISSUE_PARTNER_STATUSES[index - 1],
        statusId,
        ISSUE_PARTNER_STATUSES[index + 1],
    ].filter(truthy => truthy);

    return (
        <Field
            className={classes.select}
            component={Select}
            disabled={disabled}
            fullWidth
            id={domId}
            isClearable={false}
            label="Status"
            name="statusId"
            options={getIssueStatusOptions(statuses).map(({ labelKey, value }) => ({
                label: formatMessage({ id: labelKey }),
                value,
            }))}
            sortOptions={false}
        />
    );
}
